import styled from '@emotion/styled'
import { mobileQuery } from '@globals/themes/themeConstants'
import Typography, { TypographyProps } from '@mui/material/Typography'
import { ReactNode } from 'react'

export const ListStyled = styled('ul')({
  listStyleType: 'disc',
  paddingLeft: 20,
  margin: 0,
})

const StyledTypography = styled(Typography)({
  marginTop: 0,
  [mobileQuery]: {
    marginTop: 0,
  },
})

export const HeaderStyled = ({
  variant = 'h3',
  children,
  ...props
}: TypographyProps & { children?: ReactNode }) => {
  return (
    <StyledTypography variant={variant} {...props}>
      {children}
    </StyledTypography>
  )
}
